<form [formGroup]="form" (ngSubmit)="onSave()">
	@if (httpError == '400') {
		<mat-error class="top-right-absolute-error-message">
			{{ 'mes.scanning-prefix.errors.bad-request' | translate }}
		</mat-error>
	}

	<h1 mat-dialog-title class="notification-title no-select">
		{{ 'mes.scanning-prefix.dialog.update.header' | translate }}
	</h1>

	<mat-dialog-content style="padding-top: 20px">
		@if (httpError == '409') {
			<mat-error>{{ 'mes.scanning-prefix.errors.duplicate' | translate }}</mat-error>
		}
		@if (controls['prefix'].invalid && controls['prefix'].touched) {
			<mat-error>
				{{ 'mes.scanning-prefix.errors.invalid-characters' | translate }}
			</mat-error>
		}
		<mat-form-field appearance="outline" class="dialog">
			<mat-label class="mat-body-1">
				{{ 'mes.scanning-prefix.shared.prefix' | translate }}
			</mat-label>
			<input maxlength="255" matInput formControlName="prefix" />
		</mat-form-field>
	</mat-dialog-content>
	<div>
		<div mat-dialog-actions align="end">
			<button mat-flat-button color="primary" type="submit" [disabled]="loading || form.invalid">
				{{ 'mes.administration.terminal.shared.savebtn' | translate }}
			</button>
			<button mat-stroked-button type="button" (click)="onCancel()" (window:keyup.escape)="onCancel()" class="button-border-color">
				{{ 'mes.administration.terminal.shared.cancelbtn' | translate }}
			</button>
		</div>
	</div>
</form>
